<template>
<div class="shopCompList box-shadow padding-20">
    <div class="shopCompTitle">增加组件</div>
    <div>
        <el-button plain class="shopcomtype" v-for="(shopComp, index) in list"
                   :key="index" @click="addComp(shopComp.comp)" :disabled="shopComp.disabled">{{shopComp.label}}</el-button>
    </div>
</div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import $ from 'jquery'
export default {
    name: 'shopCompList',
    data() {
        return {
            isShow: false,
            shopCompList: [
                {
                    label: '知识商品',
                    disabled: false,
                    comp: {
                        cominnerid: '',
                        label: '知识商品',
                        comtype: 'knowledge',
                        isdisplaytitle: 1,
                        titlename: '',
                        isdisplayall: true,
                        datasource: 2,
                        liststyle: 'detail',
                        tagname: '',
                        taginnerid: '',
                        datacount: 0,
                        datalist: [
                            {
                                description: "<p>热台湾人</p>",
                                duration: 0,
                                isFree: 1,
                                isFreeText: "免费",
                                kmcinnerid: "GFWTamoadoAqYgEB",
                                kmcname: "燃放热水",
                                kmctype: 1,
                                kmctypeText: "图文",
                                logoPic: {},
                                saleprice: 0,
                                uprice: 0,
                                viewcount: 0
                            }
                        ]
                    }
                },
                {
                    label: '直播商品',
                    disabled: false,
                    comp: {
                        cominnerid: '',
                        label: '直播商品',
                        comtype: 'alive',
                        isdisplaytitle: 1,
                        titlename: '',
                        isdisplayall: true,
                        datasource: 1,
                        liststyle: 'detail',
                        tagname: '',
                        taginnerid: '',
                        datacount: 0,
                        datalist: []
                    }
                },
                {
                    label: '活动信息',
                    disabled: false,
                    comp: {
                        cominnerid: '',
                        label: '活动信息',
                        comtype: 'activity',
                        isdisplaytitle: 1,
                        titlename: '',
                        isdisplayall: true,
                        datasource: 1,
                        liststyle: 'detail',
                        tagname: '',
                        taginnerid: '',
                        datacount: 0,
                        datalist: []
                    }
                },
                {
                    label: '图文广告',
                    disabled: false,
                    comp: {
                        label: '图文广告',
                        comtype: 'imagead',
                        limit: 10,
                        datalist: []
                    }
                },
                {
                    label: '图文导航',
                    disabled: false,
                    comp: {
                        label: '图文导航',
                        comtype: 'categorynav',
                        limit: 10,
                        datacount: 3,
                        datalist: []
                    }
                },
                {
                    label: '星球',
                    disabled: false,
                    comp: {
                        label: '星球',
                        comtype: 'star',
                        isdisplaytitle: 1,
                        titlename: '',
                        isdisplayall: true,
                        datasource: 1,
                        liststyle: 'detail',
                        tagname: '',
                        taginnerid: '',
                        datacount: 0,
                        datalist: []
                    }
                },
                {
                    label: '商品搜索',
                    disabled: false,
                    comp: {
                        label: '搜索框',
                        comtype: 'searchbar'
                    }
                },
                {
                    label: '优惠券',
                    disabled: false,
                    comp: {
                        label: '优惠券',
                        comtype: 'coupon',
                        isdisplaytitle: 1,
                        titlename: '',
                        isdisplayall: true,
                        datasource: 1,
                        liststyle: 'detail',
                        tagname: '',
                        taginnerid: '',
                        datacount: 2,
                        datalist: []
                    }
                },
                {
                    label: '星球帖子',
                    disabled: false,
                    comp: {
                        label: '星球帖子',
                        comtype: 'starsubject',
                        isdisplaytitle: 1,
                        titlename: '',
                        isdisplayall: true,
                        datasource: 1,
                        liststyle: 'detail',
                        tagname: '',
                        taginnerid: '',
                        datacount: 2,
                        datalist: []
                    }
                }
            ],
            list: []
        }
    },
    mounted() {
        this.openCompAdd()
        this.index = -1
    },
    methods: {
        openCompAdd() {
            this.list = $.extend(true, [], this.shopCompList)
            this.index = this.selectCom.index
            // this.isShow = true
            // this.list.forEach(obj1 => {
            //     this.shopMob.forEach(obj2 => {
            //         if (obj1.comp.comtype === obj2.comtype) {
            //             obj1.disabled = true
            //         }
            //     })
            // })
        },
        closeCompAdd() {
            this.isShow = false
        },
        addComp(comp) {
            let tmpList = Object.assign([], this.shopMob)
            let index = this.index
            if (this.index === -1) {
                index = tmpList.length
            } else {
                index = this.selectCom.index
            }
            tmpList.splice(index, 0, comp)
            this.setShopMob(tmpList)
            this.setSelectCom({index: index, name: comp.comtype})
            this.$emit('setNewCompTop', false, index)
        },
        ...mapActions([
            'setShopMob',
            'setSelectCom'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'shopMob',
            'selectCom'
        ])
    },
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/mixin";
.shopCompList {
    .shopCompTitle{
        text-align: center;
        margin-bottom: 10px;
        color: $tcolor-base;
    }
    .shopcomtype{
        margin: 7px;
    }
    .el-button.is-plain:focus, .el-button.is-plain:hover {
        background: $bgcolor-lightbase;
        border-color: #409EFF;
        color: #409EFF;
    }
}
</style>
